import type { BillingAttachmentMetadata } from '@policyvision/contracts';

import { Client } from '@/common/services/Client';

export async function fetchAttachmentMetadata(
  attachmentId: number,
): Promise<BillingAttachmentMetadata> {
  const response = await Client.get<BillingAttachmentMetadata>({
    endpoint: `/attachments/${attachmentId}/metadata`,
  });
  return response.data;
}
